export default __webpack_public_path__ + "static/media/e2-room-bg.93d9a4ff.png";